import React from 'react'

import { SiteContext } from 'context/site-context'

import cn from 'classnames'

import { formatPhoneNumber } from 'helpers'

import ReCaptchaV2 from 'react-google-recaptcha'

import TextField from 'components/atoms/TextField'
import TextAreaInput from 'components/atoms/TextAreaInput'

import './index.scss'

const ContactModal = ({
  businessSecuredEmail = '',
  businessName = '',
  businessId = '',
  businessPhone = '',
  show = false,
  handleClose = () => {},
}) => {
  const [ site ] = React.useContext(SiteContext)

  const [ state, setState ] = React.useState({
    businessSecuredEmail: businessSecuredEmail,
    businessName: businessName,
    businessId: businessId,
    name: '',
    fromEmail: '',
    subject: '',
    message: '',
    'g-recaptcha-response': '',
    cgmRecaptchaResponse: '',
    errors: [],
    isValid: false,
    frame: 'form'
  })

  const handleChange = (key, value) => {
    const errors = state.errors
    if(errors.indexOf(key) > -1) { errors.splice(errors.indexOf(key), 1)}
    setState({
      ...state,
      [key]: value,
      errors: errors,
    })
  }

  const handleSubmit = () => {
    if(isValid()) {
      setState({
        ...state,
        isLoading: true,
      })

      const payload = {
        ...state,
      }

      const URL = `http://www.citysearch.com/profile/email_business/${businessId}?ajax=1`

      try {
        fetch(URL, {
          method: 'POST',
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        })
        .then( response => response.json() )
        .then( data => {
          setState({
            ...state,
            frame: 'success',
          })
        })
        .catch ( e => {
          // console.log(e)
          setState({
            ...state,
            frame: 'error',
          })
        })
      }
      catch (e) {
        console.dubug(e)
        setState({
          ...state,
          frame: 'error',
        })
      }
    }
  }

  const handleKeyDown = React.useCallback( e => {
    if(e.keyCode === 13) { // 'User pressed enter key')
      handleSubmit()
    }
  }, [handleSubmit])

  const isValid = () => {
    let isValid = true
    const errors = []

    if(state.name.trim().length === 0){
      isValid = false
      errors.push('name')
    }

    if(!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(state.fromEmail)) {
      isValid = false
      errors.push('fromEmail')
    }

    if(state.subject.trim().length === 0){
      isValid = false
      errors.push('subject')
    }

    if(state.message.trim().length === 0){
      isValid = false
      errors.push('message')
    }

    if(site.recaptcha_site_key && state['g-recaptcha-response'].trim().length === 0 || state.cgmRecaptchaResponse.trim().length === 0){
      isValid = false
      errors.push('recaptcha')
    }

    setState({
      ...state,
      errors: errors,
      isValid: isValid,
    })

    return isValid
  }

  const handleToken = token => {
    setState({
      ...state,
      'g-recaptcha-response': token,
      cgmRecaptchaResponse: token,
    })
  }

  const handleExpire = () => {
    setState({
      ...state,
      'g-recaptcha-response': '',
      cgmRecaptchaResponse: '',
    })
  }

  return <React.Fragment>
   {show && <div className="contact-modal-container">
      <div className="overlay" onClick={ () => handleClose() } />
      <div className="modal">
        <div className="close-trigger" onClick={ () => handleClose()}>X</div>
        <div className="modal-title">Contact</div>
        <div className="modal-body">
          {state.frame === 'form' && <React.Fragment>
            {state.errors.length > 0 && <p className="error-message">* All Fields Required, check information provided is accurate</p>}
            <TextField label="Name"
              type="text"
              hasError={state.errors.indexOf('name') > -1}
              value={state.name}
              onChange={ value => handleChange('name', value) } />

            <TextField label="Email"
              hasError={state.errors.indexOf('fromEmail') > -1}
              value={state.fromEmail}
              onChange={ value => handleChange('fromEmail', value)} />

            <TextField label="Subject"
              hasError={state.errors.indexOf('subject') > -1}
              value={state.subject}
              onChange={ value => handleChange('subject', value)} />

            <TextAreaInput label="Message"
              hasError={state.errors.indexOf('message') > -1}
              value={state.message}
              onChange={ value => handleChange('message', value)} />

            {site.recaptcha_site_key && <div className={cn('recaptcha-container', {'error': state.errors.indexOf('recaptcha') > -1} )}>
              <ReCaptchaV2 sitekey={site.recaptcha_site_key}
                onChange={handleToken}
                onExpired={handleExpire} />
            </div>}

            <span className="button-trigger submit" tabIndex="0" onClick={ () => handleSubmit() }>Get Contacted!</span>
          </React.Fragment>}
          {state.frame === 'success' && <React.Fragment>
            <h3>Thanks!</h3>
            <p>{businessName} has been contacted and you should receive a communication soon.</p>
            <strong>Don't want to wait?</strong>
            <p>You can contact the business right away at <a href={`tel:${businessPhone}`} className="phone">{formatPhoneNumber(businessPhone)}</a></p>
            <div className="button-trigger close" onClick={() => handleClose()}>Close</div>
          </React.Fragment>}
          {state.frame === 'error' && <React.Fragment>
            <h3>We're sorry, but something went wrong.</h3>
            <p>Please try again later or contact the business directly at <a href={`tel:${businessPhone}`} className="phone">{formatPhoneNumber(businessPhone)}</a></p>
            <div className="button-trigger close" onClick={() => handleClose()}>Close</div>
          </React.Fragment>}
        </div>
      </div>
    </div>
  }
  </React.Fragment>
}

export default ContactModal
